import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function CortesCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ORDENES_CORTE = process.env.REACT_APP_URL_ORDENES_CORTE;
  const URL_CORTES = process.env.REACT_APP_URL_CORTES;
  const URL_ARTICULOS_ORDENES_CORTE =
    process.env.REACT_APP_URL_ARTICULOS_ORDENES_CORTE;
  const URL_ARTICULOS_CORTES = process.env.REACT_APP_URL_ARTICULOS_CORTES;
  const URL_INVENTARIOS_TABLEROS = process.env.REACT_APP_URL_INVENTARIOS_TABLEROS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");
  const ordenTallas = ["EXTRA CHICA", "CHICA", "M", "MEDIANA", "GRANDE", "EXTRA GRANDE", "VARIOS", "INDIVIDUAL", "MATRIMONIAL", "QUEEN", "KING", "32", "34", "36", "38", "40", "42"];
  const [ordenesCorte, setOrdenesCorte] = useState([]);
  const [selectedOrden, setSelectedOrden] = useState("");
  const [idArticulo, setIdArticulo] = useState("");
  const [value, setValue] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [cliente, setCliente] = useState("");
  const [idCliente, setIdCliente] = useState("");
  const [idPedido, setIdPedido] = useState("");
  const [fecha, setFecha] = useState(hoy);
  const [mesa, setMesa] = useState(0);
  const [fecha_compromiso, setFechaCompromiso] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [total_piezas, setTotalPiezas] = useState(0);
  const [piezas, setPiezas] = useState(0);
  const [lienzos, setLienzos] = useState(0);
  const [empalmes, setEmpalmes] = useState(0);
  const [retaceria, setRetaceria] = useState(0);
  const [largoTrazo, setLargoTrazo] = useState(0);
  const [responsable1, setResponsable1] = useState("6275525ae9b2950360d3fa02");
  const [responsable2, setResponsable2] = useState("6275525ae9b2950360d3fa02");
  const [tiempoInicio, setTiempoInicio] = useState("");
  const [tiempoFin, setTiempoFin] = useState("");

  const [articulosOrden, setArticulosOrden] = useState([]);
  const [fecha_orden, setFechaOrden] = useState("");
  const [total_piezas_orden, setTotalPiezasOrden] = useState(0);
  const [total_general_orden, setTotalGeneralOrden] = useState(0);

  const [articulosUnicos, setArticulosUnicos] = useState([]);
  const [articulosUnicos2, setArticulosUnicos2] = useState([]);



  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      cantidad: 0,
      idArticulosOrden: "",
      idArticulo: "",
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(`${URL_ORDENES_CORTE}NoCortadas`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allOrdenesCorte = res.data;
        setOrdenesCorte(allOrdenesCorte);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColaboradores = res.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const saveCorte = async (event) => {
    event.preventDefault();
    if (fecha != "") {
      setValidaBoton(false);
      toggleProgreso();

      // calculaCorte();
      let totalRollos = articulosOrden.length;
      try {
        await axios
          .post(
            URL_CORTES,
            {
              fecha,
              mesa,
              ordenesCorte: selectedOrden,
              pedidos: idPedido,
              total_cantidad: total_piezas,
              lienzos,
              piezas,
              observaciones,
              empalmes,
              retaceria,
              largoTrazo,
              tiempoInicio,
              tiempoFin,
              responsable1,
              responsable2,
              status:"Abierto",
              articulos: idArticulo
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((data) => {
            axios.patch(
              `${URL_INVENTARIOS_TABLEROS}/cortesCreate/${selectedOrden}`,
              {
                cortes: data.data._id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
            articulosOrden.map((a) => {
              if (a.cantidad > 0) {
                axios
                  .post(
                    URL_ARTICULOS_CORTES,
                    {
                      cortes: data.data._id,
                      pedidos: idPedido,
                      articulosOrdenesCorte: a._id,
                      total_cantidad: parseFloat(a.cantidad),
                      cantidad_procesos: parseFloat(a.cantidad),
                      faltanteRecibir: parseFloat(a.cantidad),
                      fecha,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    totalRollos = totalRollos - 1;
                    if (totalRollos == 0) {
                      axios
                        .post(
                          URL_LOGS,
                          {
                            tipo: "Crear Corte",
                            detalle: `${data.data._id}`,
                            user: user.id,
                          },
                          {
                            headers: {
                              Authorization: `Bearer: ${localStorage.getItem(
                                "app_token"
                              )}`,
                            },
                          }
                        )
                        .then(() => {
                          Swal.fire("Good job!", "Creado con exito", `success`);
                          setTimeout(() => {
                            window.location.reload();
                          }, 1000);
                        })
                        .catch((error) => {
                          Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Something went wrong!",
                            footer: `${error.response.data}`,
                          });
                          console.log(error);
                          setValidaBoton(true);
                        });
                    }
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                    setValidaBoton(true);
                  });
              } else {
                totalRollos = totalRollos - 1;
                if (totalRollos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Crear Corte",
                        detalle: `${data.data._id}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", `success`);
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              }
            });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
            setValidaBoton(true);
          });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `Faltan Datos`,
      });
    }
  };

  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        cantidad: 0,
        idArticulosOrden: "",
        idArticulo: "",
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let totalMts = values.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalPiezas(TM);
  };

  function BuscaArticulo(id, event) {
    articulosOrden.map((a) => {
      if (a.idArticulo == event.target.value) {
        let idArticulo = a.idArticulo;
        handleChangeInputArticulo(id, idArticulo);
      }
    });
  }

  const handleChangeInputArticulo = (id, idArticulo) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.idArticulo = idArticulo;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales()
  };

  function ActualizaTotales() {
    let totalMts = articulosOrden.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalPiezas(TM);
  }

  function jalaOrden(e) {
    setSelectedOrden(e);

    axios
      .get(`${URL_ARTICULOS_ORDENES_CORTE}/orden/${e}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulosOrden = res.data;
        let arrayTabla = allArticulosOrden.map((a) => {
          return {
            _id: a._id,
            idArticulo: a.articulosPedido[0].articulos[0]._id,
            articuloNombre: a.articulosPedido[0].articulos[0].codigo + " / " + a.articulosPedido[0].articulos[0].descripcion,
            color: a.articulosPedido[0].colores[0].name,
            cantidad: a.cantidad,
            cantidadOrden: a.cantidad,
          };
        });
        let dataFinal = Object.values(arrayTabla);
        setArticulosOrden(dataFinal);
        setIdArticulo(dataFinal[0].idArticulo);

        let agrupado = dataFinal.reduce(function (groups, item) {
          const val = item["idArticulo"];
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo,
          };
          groups[val].idArticulo = item.idArticulo;
          groups[val].articuloNombre = item.articuloNombre;
          return groups;
        }, []);
        let dataFinalAgru = Object.values(agrupado);
        setArticulosUnicos(dataFinalAgru);

        let agrupado2 = dataFinal.reduce(function (groups, item) {
          const val = item["idArticulo"] + item["color"];
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo,
            color: item.color,
          };
          groups[val].idArticulo = item.idArticulo;
          groups[val].color = item.color;
          groups[val].articuloNombre = item.articuloNombre;
          return groups;
        }, []);
        let dataFinalAgru2 = Object.values(agrupado2);
        setArticulosUnicos2(dataFinalAgru2);
      })
      .catch((err) => {
        console.log(err);
      });

    ordenesCorte.map((a) => {
      if (a._id == e) {
        setFechaOrden(a.fecha);
        setCliente(a.pedidos[0].clientes[0].nombre_comercial);
        setIdCliente(a.pedidos[0].clientes[0]._id);
        setIdPedido(a.pedidos[0]._id);
      }
    });
  }

  const handleChangeInputCantidad = (id, event) => {
    const newArticulosOrden = articulosOrden.map((i) => {
      if (id === i._id) {
        i.cantidad = parseFloat(event.target.value);
      }
      return i;
    });
    setArticulosOrden(newArticulosOrden);

    ActualizaTotales();
  };

  const options = ordenesCorte.map((option) => {
    const junta = option.idOrdenesCorte + " " + option.pedidos[0].clientes[0].nombre_comercial + " " + option.pedidos[0].articulos[0].codigo;
    const firstLetter = option.idOrdenesCorte.toString();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_produccion ? (
        <div className="card container col-10">
          <h3 align="center">Nuevo Corte</h3>
          <Form>
            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Orden de Produccion</Label>
                {/* <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedOrden}
                  required
                  onChange={(e) => jalaOrden(e.target.value)}
                >
                  <option value="0">Selecciona una Orden</option>
                  {ordenesCorte
                    .sort((a, b) =>
                      a.numero < b.numero ? 1 : -1
                    )
                    .map((a) => {
                      if (a.cortado == "No") {
                        return (
                          <option value={a._id}>
                            OC # {a.numero} {a.pedidos[0].idPedido} {a.pedidos[0].clientes[0].nombre_comercial} {a.pedidos[0].articulos[0].codigo} {a.pedidos[0].articulos[0].codigoCliente}
                          </option>
                        );
                      }
                    })}
                </Input> */}
                <Autocomplete
                    size="small"
                    value={value}
                    onChange={(event, selectedOrden) => {
                      if (selectedOrden) {
                        setValue(selectedOrden);
                        jalaOrden(selectedOrden._id);
                      }
                    }}
                    options={options.sort(
                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                    )}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option.junta}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecciona"
                        variant="outlined"
                      />
                    )}
                    renderOption={(option) => (
                      <React.Fragment>
                        {option.idOrdenesCorte} {option.pedidos[0].clientes[0].nombre_comercial} {option.pedidos[0].articulos[0].codigo}
                      </React.Fragment>
                    )}
                  />
              </Col>
              <Col md={2}>
                <Label>Fecha Orden</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha_orden}
                  required
                  disabled
                  onChange={(e) => {
                    setFechaOrden(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Cliente</Label>
                <Input
                  type="text"
                  placeholder="Cliente"
                  value={cliente}
                  required
                  disabled
                  onChange={(e) => {
                    setCliente(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>Fecha Corte</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  onChange={(e) => {
                    setFecha(e.target.value);
                  }}
                />
              </Col>
              {/* <Col md={2}>
                <Label>Mesa</Label>
                <Input
                  type="select"
                  placeholder="Mesa"
                  value={mesa}
                  required
                  onChange={(e) => {
                    setMesa(e.target.value);
                  }}
                >
                  <option value="0">Selecciona</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                  <option value="12">12</option>
                </Input>
              </Col> */}
            </Row>
            <Row>
            <Col md={2}>
                <Label className="mr-sm-2">Responsable 1</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={responsable1}
                  required
                  onChange={(e) => setResponsable1(e.target.value)}
                >
                  <option value="0">Selecciona</option>
                  {colaboradores
                    .sort((a, b) =>
                      a.nombre > b.nombre ? 1 : -1
                    )
                    .map((a) => {
                      // if (a.cortado == "No") {
                        return (
                          <option value={a._id}>
                            {a.nombre} {a.apellido}
                          </option>
                        );
                      // }
                    })}
                </Input>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Responsable 2</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={responsable2}
                  required
                  onChange={(e) => setResponsable2(e.target.value)}
                >
                  <option value="0">Selecciona</option>
                  {colaboradores
                    .sort((a, b) =>
                      a.nombre > b.nombre ? 1 : -1
                    )
                    .map((a) => {
                      // if (a.cortado == "No") {
                        return (
                          <option value={a._id}>
                            {a.nombre} {a.apellido}
                          </option>
                        );
                      // }
                    })}
                </Input>
              </Col>
            {/* <Col md={2}>
                <Label>Lienzos</Label>
                <Input
                  type="number"
                  placeholder="Lienzos"
                  value={lienzos}
                  required
                  onChange={(e) => {
                    setLienzos(e.target.value);
                  }}
                />
              </Col>
            <Col md={2}>
                <Label>Empalmes</Label>
                <Input
                  type="number"
                  placeholder="Empalmes"
                  value={empalmes}
                  required
                  onChange={(e) => {
                    setEmpalmes(e.target.value);
                  }}
                />
              </Col>
            <Col md={2}>
                <Label>Retaceria</Label>
                <Input
                  type="number"
                  placeholder="Retaceria"
                  value={retaceria}
                  required
                  onChange={(e) => {
                    setRetaceria(e.target.value);
                  }}
                />
              </Col> */}
            {/* <Col md={2}>
                <Label>Largo de Trazo</Label>
                <Input
                  type="number"
                  placeholder="Largo de Trazo"
                  value={largoTrazo}
                  required
                  onChange={(e) => {
                    setLargoTrazo(e.target.value);
                  }}
                />
              </Col> */}
            {/* </Row>
            <Row> */}
              <Col md={2}>
                <Label>Hora Inicio</Label>
                <Input
                  type="datetime-local"
                  value={tiempoInicio}
                  required
                  onChange={(e) => {
                    setTiempoInicio(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>Hora Fin</Label>
                <Input
                  type="datetime-local"
                  value={tiempoFin}
                  required
                  onChange={(e) => {
                    setTiempoFin(e.target.value);
                  }}
                />
              </Col>
            {/* </Row>
            <Row> */}

            {/* <Col md={2}>
                <Label>Piezas</Label>
                <Input
                  type="number"
                  placeholder="Piezas"
                  value={piezas}
                  required
                  onChange={(e) => {
                    setPiezas(e.target.value);
                  }}
                />
              </Col> */}
            <Col md={2}>
                <Label>Observaciones</Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES {new Intl.NumberFormat("en-US").format(total_piezas)}{" "}
                  pzas.
                </h4>
              </Col>
            </Row>

            {/* Tabla Articulos */}
            <br />
            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Articulos</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="idArticulo"
                      type="select"
                      value={inputField.idArticulo}
                      onChange={(event) => {
                        BuscaArticulo(inputField.id, event);
                      }}
                    >
                      <option value="">Selecciona un Articulo</option>
                      {articulosUnicos
                        .sort((a, b) =>
                          a.articuloNombre > b.articuloNombre ? 1 : -1
                        )
                        .map((a) => {
                          return (
                            <option value={a.idArticulo}>
                              {a.articuloNombre}
                            </option>
                          );
                        })}
                    </Input>
                  </Col>

                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>

                {articulosUnicos2.map((col) => {
                  if (col.idArticulo == inputField.idArticulo) {
                    return (
                      <>
                        <Row>
                          <Col md={9} className="tallas">
                            <Col md={1}>
                              <Label>{col.color}</Label>
                            </Col>
                            {articulosOrden
                              .sort((a, b) => {
                                const indexA = ordenTallas.indexOf(a.talla);
                                const indexB = ordenTallas.indexOf(b.talla);
                
                                // Si la talla no está en el orden definido, colócala al final
                                return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
                              })
                            .map((a) => {
                              if (col.color == a.color) {
                                return (
                                  <>
                                  <table>
                                    <td>
                                      <Label>
                                        {a.cantidadOrden}
                                      </Label>
                                    </td>
                                    <td>
                                      <Input
                                        bsSize="sm"
                                        name="cantidad"
                                        type="number"
                                        value={a.cantidad}
                                        required
                                        onChange={(event) =>
                                          handleChangeInputCantidad(
                                            a._id,
                                            event
                                          )
                                        }
                                      />
                                    </td>
                                    </table>
                                  </>
                                );
                              }
                            })}
                          </Col>
                        </Row>
                      </>
                    );
                  }
                })}

                <br />
              </div>
            ))}
            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES {new Intl.NumberFormat("en-US").format(total_piezas)}{" "}
                  pzas
                </h4>
              </Col>
            </Row>
            {/* Termina Tabla Articulos */}
          </Form>

          <br />
          <Row>
            <Col>
              {validaBoton ? (
                <Button
                  type="submit"
                  className="btn btn-success"
                  tabindex="-1"
                  onClick={saveCorte}
                >
                  Guardar
                </Button>
              ) : (
                <Button
                  type="submit"
                  className="btn btn-success"
                  disabled
                  tabindex="-1"
                >
                  Guardar
                </Button>
              )}
              <Button
                href="/ListadoCortes"
                className="btn btn-danger"
                id="botonListado"
                tabindex="-1"
              >
                Regresar
              </Button>
            </Col>
          </Row>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios minutos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default CortesCreate;
